<template>
  <div>
    <!-- TODO: refactor markup User Data Component-->
    <ul class="user-info-list">
      <li class="user-name">
        <small>{{userData.title}} {{userData.fname}} {{userData.lname}}</small>
      </li>
      <li class="log-user">
        <small>{{userData.name}}</small>
      </li>
    </ul>
  </div>
</template>

<script>
import authMixin from 'b2b-common/mixins/auth'

export default {
  mixins: [authMixin]
}
</script>
<style lang="scss">

</style>
